/**
 * Global axios Authorization header from localStorage token.
 * Import once from app entry so all axios.* calls send Bearer token.
 */
import axios from 'axios';
import { getAccessToken } from '../services/tokenStore';

let installed = false;

export function installAxiosAuthInterceptor(): void {
  if (installed) return;
  installed = true;
  axios.interceptors.request.use((config) => {
    const token = getAccessToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
}
